import {
  SEARCH_FACTORYSETTINGS_API,
  CREATE_FACTORYSETTING_API,
  UPDATE_FACTORYSETTING_API,
  DELETE_FACTORYSETTINGS_API,
  GET_FACTORYSETTINGS_DETAIL_API,
  GET_GROUPLISTBYDEVICEFORMATIONID_API
} from '~/constants/APIs'
import {
  FactorySettingDetailType,
  FactorySettingGroupListType,
  IFactorySettingForm,
  IFactorySettingSearchForm,
  IFactorySettingSearchResponse,
} from '~/models'
import axiosClient from './axiosClient'

export const factorySettingApis = {

  searchFactorySettings: (data: IFactorySettingSearchForm) => {
    return axiosClient.get(SEARCH_FACTORYSETTINGS_API, {
      params: { ...data }
    }) as unknown as IFactorySettingSearchResponse
  },

  createFactorySetting: (data: IFactorySettingForm) => axiosClient.post(CREATE_FACTORYSETTING_API, data),

  updateFactorySetting: (data: IFactorySettingForm) => axiosClient.put(UPDATE_FACTORYSETTING_API + data.id, data),

  deleteFactorySetting: (data: any) => axiosClient.delete(DELETE_FACTORYSETTINGS_API, { data }),

  getFactorySettingDetail: (factorySettingId: number) =>
    axiosClient.get(GET_FACTORYSETTINGS_DETAIL_API + String(factorySettingId)) as unknown as FactorySettingDetailType,

  getFactoryGroupList: (deviceFormationId: number, fleetId: string) =>
    deviceFormationId == null ? [] : axiosClient.get(GET_GROUPLISTBYDEVICEFORMATIONID_API + String(deviceFormationId) + "?fleetId=" + String(fleetId)) as unknown as FactorySettingGroupListType[],
}
